import { colors } from '../../colors';
var fiveCard = {
  textColor: colors.nvaBlack,
  hoverColor: colors.nvaTeal,
  bgColorPara: colors.white,
  bgColor: colors.white,
  cardBgColorB: colors.white,
  cardBgColorHoverB: colors.nvaTeal,
  cardCTAColorB: colors.nvaTeal,
  cardCTAColorHoverB: colors.white
};
export default fiveCard;